module.exports = __webpack_public_path__ + "static/media/Repeat_grid_5.9ab52f39.svg";